import { handleActions } from 'redux-actions';
import { TrustedDeviceResponse, UserTrustedDevicesState } from './interfaces';
import { Types } from './types';

const initialState: UserTrustedDevicesState = {
  isLoading: false,
  trustedDevicesList: {} as TrustedDeviceResponse,
  isLoadingTrustedDevicesList: false,
  isDeleting: false,
};

export default handleActions(
  {
    [Types.GET_USER_TRUSTED_DEVICES_REQUEST]: (
      state: UserTrustedDevicesState
    ): UserTrustedDevicesState => ({
      ...state,
      isLoadingTrustedDevicesList: true,
    }),
    [Types.GET_USER_TRUSTED_DEVICES_FULFILLED]: (
      state: UserTrustedDevicesState,
      { payload }
    ): UserTrustedDevicesState => ({
      ...state,
      trustedDevicesList: payload,
      isLoadingTrustedDevicesList: false,
    }),
    [Types.GET_USER_TRUSTED_DEVICES_REJECTED]: (
      state: UserTrustedDevicesState
    ): UserTrustedDevicesState => ({
      ...state,
      isLoadingTrustedDevicesList: false,
    }),

    [Types.DELETE_TRUSTED_DEVICE_REQUEST]: (
      state: UserTrustedDevicesState
    ): UserTrustedDevicesState => ({
      ...state,
      isDeleting: true,
    }),
    [Types.DELETE_TRUSTED_DEVICE_FULFILLED]: (
      state: UserTrustedDevicesState
    ): UserTrustedDevicesState => ({
      ...state,
      isDeleting: false,
    }),
    [Types.DELETE_TRUSTED_DEVICE_REJECTED]: (
      state: UserTrustedDevicesState
    ): UserTrustedDevicesState => ({
      ...state,
      isDeleting: false,
    }),
  },
  initialState
);
